import create from 'zustand';
import { Biz } from '@/typings/open.platform.forum_bff/namespaces/configure';

export interface BizState {
  biz: Biz;
  changeBiz: (biz: Biz) => void;
}

// 获取业务线 服务商  or 开发者
export const useBiz = create<BizState>(set => ({
  biz: Biz.All,
  changeBiz: biz => set(state => ({ ...state, biz })),
}));

export default useBiz;
